module.exports = __webpack_public_path__ + "img/b8.aba63bbc.jpg";